import React, { useEffect, useRef } from "react";
import { FiMenu, FiChevronDown } from "react-icons/fi";
import defaultAvatar from "../images/defaultAvatar.png";
import { getUserImageUrl } from "../constants/config";
import { unwrapUser } from "../utilities/adminAccess";
import DropdownMenu from './DropdownMenu';
import ChampionshipSelector from './ChampionshipSelector';
import GlobalSearch from './GlobalSearch';
import { useI18n } from "../utilities/i18n";

const resolveUserImage = (userData) => {
  const user = unwrapUser(userData);
  return user?.image || userData?.image || userData?.data?.image || '';
};

const avatarSrc = (userData) => {
  const image = resolveUserImage(userData);
  const url = getUserImageUrl(image);
  if (!url) return '';
  const rev = userData?.image_rev || unwrapUser(userData)?.image_rev;
  if (rev) {
    return `${url}${url.includes('?') ? '&' : '?'}v=${rev}`;
  }
  return url;
};

function AdminHeader(props) {
  const { t } = useI18n();
  const accountRef = useRef(null);

  useEffect(() => {
    if (!props.dropDownVisible) {
      return undefined;
    }

    const handleClickOutside = (event) => {
      if (accountRef.current && !accountRef.current.contains(event.target)) {
        props.closeDropDown();
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        props.closeDropDown();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [props.dropDownVisible, props.closeDropDown]);

  const renderUserImage = () => {
    const src = avatarSrc(props.userData);
    return (
      <img
        src={src || defaultAvatar}
        className="adminHeaderUserImage"
        alt=""
        onError={(event) => { event.currentTarget.src = defaultAvatar; }}
      />
    );
  }

  const userName = props.userData
    ? [props.userData.name, props.userData.family].filter(Boolean).join(" ")
    : "";

  return (
    <div className="adminHeaderWrapper">
      <div className="adminHeader">
        <div className="adminHeaderLeft">
          <button
            type="button"
            className="adminHeaderMenuBtn"
            onClick={()=>props.toggleSideBar()}
            aria-label={t('menu')}
          >
            <FiMenu size="1.35em" color="#edf5ff"/>
          </button>
        </div>
        <GlobalSearch />
        <div className="adminHeaderRight">
          <ChampionshipSelector />
          <div className="adminHeaderAccount" ref={accountRef}>
            <div onClick={props.toggleDropDown} className="adminHeaderUserBlock">
              {renderUserImage()}
              <span className="adminHeaderUserName" title={userName || undefined}>
                {userName}
              </span>
              <FiChevronDown size="1.1em" color="#edf5ff"/>
            </div>
            <div className="dropDownMenuWrapper">
              <DropdownMenu
                logOut={props.logOut}
                onEditAccount={props.onEditAccount}
                userData={props.userData}
                visible={props.dropDownVisible}
              />
            </div>
          </div>
        </div>
      </div>
    </div> 
  );
}

export default AdminHeader;
